/* ========================================================================
 * Send event to traking utils : GA
 * ======================================================================== */
function analyticsTrackEvent( category, action, label ){
  // send ga event
  if( typeof dataLayer !== 'undefined' ) {
    dataLayer.push( {event:'person-click-link', eventCategory:category, eventAction:action, eventLabel: label} );
  }
}

DOMReady( function(){
  const trackedLinks = document.querySelectorAll("a[data-event][data-eventvalue]");
  trackedLinks.forEach((trackedLink) => {
    trackedLink.addEventListener('click', function(){
      analyticsTrackEvent( trackedLink.dataset.event, 'click', trackedLink.dataset.eventvalue );
    });
  });
});
